import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { ProductGroupSetDefaultCommand, ProductGroupSetDefaultCommandHandlerBase, ProductGroupSetDefaultResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(ProductGroupSetDefaultCommand)
@Injectable({ providedIn: 'root'})
export class ProductGroupSetDefaultCommandHandler {
    private commandHandler: ProductGroupSetDefaultCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new ProductGroupSetDefaultCommandHandlerBase(http);
    }

    public async handleAsync(cmd: ProductGroupSetDefaultCommand): Promise<ProductGroupSetDefaultResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
